import type { IconProps } from "~/design-system/types";

export function UploadIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.19667 19.0217 4.00067 18.5507 4 18V16C4 15.7167 4.096 15.4793 4.288 15.288C4.48 15.0967 4.71733 15.0007 5 15C5.28267 14.9993 5.52033 15.0953 5.713 15.288C5.90567 15.4807 6.00133 15.718 6 16V18H18V16C18 15.7167 18.096 15.4793 18.288 15.288C18.48 15.0967 18.7173 15.0007 19 15C19.2827 14.9993 19.5203 15.0953 19.713 15.288C19.9057 15.4807 20.0013 15.718 20 16V18C20 18.55 19.8043 19.021 19.413 19.413C19.0217 19.805 18.5507 20.0007 18 20H6ZM11 7.85L9.125 9.725C8.925 9.925 8.68767 10.021 8.413 10.013C8.13833 10.005 7.90067 9.90067 7.7 9.7C7.51667 9.5 7.42067 9.26667 7.412 9C7.40333 8.73334 7.49933 8.5 7.7 8.3L11.3 4.7C11.4 4.6 11.5083 4.52934 11.625 4.488C11.7417 4.44667 11.8667 4.42567 12 4.425C12.1333 4.42434 12.2583 4.44534 12.375 4.488C12.4917 4.53067 12.6 4.60134 12.7 4.7L16.3 8.3C16.5 8.5 16.596 8.73334 16.588 9C16.58 9.26667 16.484 9.5 16.3 9.7C16.1 9.9 15.8627 10.0043 15.588 10.013C15.3133 10.0217 15.0757 9.92567 14.875 9.725L13 7.85V15C13 15.2833 12.904 15.521 12.712 15.713C12.52 15.905 12.2827 16.0007 12 16C11.7173 15.9993 11.48 15.9033 11.288 15.712C11.096 15.5207 11 15.2833 11 15V7.85Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function RemoveIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8499 9.14001L18.1999 19.21C18.0899 20.78 17.9999 22 15.2099 22H8.7899C5.9999 22 5.9099 20.78 5.7999 19.21L5.1499 9.14001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3301 16.5H13.6601"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 12.5H14.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CloseIcon(props: IconProps) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6667 1.33337L9.00004 9.00004M9.00004 9.00004L1.33337 16.6667M9.00004 9.00004L16.6667 16.6667M9.00004 9.00004L1.33337 1.33337"
        stroke="currentColor"
        strokeWidth="1.2"
      />
    </svg>
  );
}

export function ShareIcon(props: IconProps) {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8666 16.2411C14.8666 16.2411 -0.10425 13.1441 5.09819 10.1409C9.48837 7.60676 24.6183 3.24982 26.7321 4.37557C27.8578 6.48932 23.5009 21.6193 20.9667 26.0094C17.9636 31.2119 14.8666 16.2411 14.8666 16.2411Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8652 16.241L26.7307 4.37549"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 4.375L3.43478 7L9 1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function TrashIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Delete">
        <path
          id="Stroke 1"
          d="M18.8892 9.5542C18.8892 17.5732 20.0435 21.198 12.2797 21.198C4.5149 21.198 5.693 17.5732 5.693 9.5542"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 3"
          d="M20.3652 6.47985H4.21472"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 5"
          d="M15.7149 6.47983C15.7149 6.47983 16.2435 2.71411 12.2892 2.71411C8.3359 2.71411 8.86447 6.47983 8.86447 6.47983"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
